export default "__VITE_ASSET__DipPXi8g__"